const inicialState = {
  medicoExecutante: null,
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/material/recebimento.state.js